import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { LandingComponent } from './landing/landing.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PromoListComponent } from './promo/promo-list/promo-list.component';
import { EventReservationsComponent } from './event-reservations/event-reservations.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { AdminComponent } from './admin/admin/admin.component';
import { ReservationFormComponent } from './event-reservations/reservation-form/reservation-form.component';
import { FiestaClubComponent } from './fiesta-club/fiesta-club.component';
import { SuccessComponent } from './fiesta-club/success/success.component';
import { LoginComponent } from './admin/login/login/login.component';
import { MobileAppComponent } from './mobile-app/mobile-app.component';
import { BajaFiestaComponent } from './baja-fiesta/baja-fiesta.component';
import { FiestaDeLasMadresComponent } from './fiesta-de-las-madres/fiesta-de-las-madres.component';
import { DadsAndGradsComponent } from './dads-and-grads/dads-and-grads.component';
import { TacoTuesdaysComponent } from './taco-tuesdays/taco-tuesdays.component';
import { Anniversary52ndComponent } from './anniversary-52nd/anniversary-52nd.component';
import { KidsEatFreeMondaysComponent } from './kids-eat-free-mondays/kids-eat-free-mondays.component';
import { FundraisingProgramComponent } from './fundraising-program/fundraising-program.component';
import { StarAchieversComponent } from './star-achievers/star-achievers.component';
import { NationalQuesadillaDayComponent } from './national-quesadilla-day/national-quesadilla-day.component';
import { NationalCoffeeDayComponent } from './national-coffee-day/national-coffee-day.component';
import { NationalTacoDayComponent } from './national-taco-day/national-taco-day.component';
import { DiaDeLosMuertosComponent } from './dia-de-los-muertos/dia-de-los-muertos.component';
import { HalloweenWeekComponent } from './halloween-week/halloween-week.component';
import { HolidaySeasonComponent } from './holiday-season/holiday-season.component';
import { MargaritaFlightsComponent } from './margarita-flights/margarita-flights.component';
import { JobsAnaheimHillsComponent } from './jobs-anaheim-hills/jobs-anaheim-hills.component';
import { ReservationsComponent } from './reservations/reservations.component';
import { HolidayBonusCardComponent } from './holiday-bonus-card/holiday-bonus-card.component';
import { RestaurantWeekComponent } from './restaurant-week/restaurant-week.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
  },
  {
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'checkout/:ticketID',
    component: CheckoutComponent,
  },
  {
    path: 'hours-locations',
    loadChildren:
      './hours-locations/hours-locations.module#HoursLocationsModule',
  },
  {
    path: 'event-reservations',
    component: EventReservationsComponent,
    children: [
      {
        path: ':formType',
        component: ReservationFormComponent,
      },
    ],
  },
  {
    path: 'menu',
    component: MenuComponent,
    children: [
      {
        path: ':location',
        component: MenuComponent,
        children: [
          {
            path: ':category',
            component: MenuComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'rodrigos-rewards',
    component: FiestaClubComponent,
  },
  {
    path: 'mobile-app',
    component: MobileAppComponent,
  },
  // {
  //   path: "baja-fiesta",
  //   component: BajaFiestaComponent,
  // },
  {
    path: 'baja-fiesta',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: "fiesta-de-las-madres",
    component: FiestaDeLasMadresComponent
  },
  {
    path: "dads-and-grads",
    component: DadsAndGradsComponent
  },
  {
    path: 'fiesta-club/success',
    component: SuccessComponent,
  },
  {
    path: 'legal',
    loadChildren: './legal/legal.module#LegalModule',
  },
  {
    path: 'contact',
    loadChildren: './contact/contact.module#ContactModule',
  },
  {
    path: 'about',
    loadChildren: './about/about.module#AboutModule',
  },
  {
    path: 'promos',
    component: PromoListComponent,
  },
  {
    path: 'jobs',
    loadChildren: './jobs/jobs.module#JobsModule',
  },
  {
    path: 'taco-tuesdays',
    component: TacoTuesdaysComponent,
  },
  {
    path: '52nd-anniversary',
    component: Anniversary52ndComponent,
  },
  {
    path: 'kids-eat-free-mondays',
    component: KidsEatFreeMondaysComponent,
  },
  {
    path: 'margarita-flights',
    component: MargaritaFlightsComponent,
  },
  {
    path: 'fundraising-program',
    component: FundraisingProgramComponent,
  },
  {
    path: 'star-achievers',
    component: StarAchieversComponent,
  },
  {
    path: 'national-quesadilla-day',
    component: NationalQuesadillaDayComponent,
  },
  {
    path: 'national-coffee-day',
    component: NationalCoffeeDayComponent,
  },
  {
    path: 'national-taco-day',
    component: NationalTacoDayComponent,
  },
  {
    path: 'dia-de-los-muertos',
    component: DiaDeLosMuertosComponent,
  },
  {
    path: 'halloween-week',
    component: HalloweenWeekComponent,
  },
  {
    path: 'holiday-season',
    component: HolidaySeasonComponent,
  },
  // {
  //   path: 'jobs/anaheim-hills',
  //   component: JobsAnaheimHillsComponent,
  // },
  {
    path: 'reservations',
    component: ReservationsComponent,
  },
  {
    path: 'holiday-bonus-card',
    component: HolidayBonusCardComponent,
  },
  {
    path: 'restaurant-week',
    component: RestaurantWeekComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class RoutesModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts